'use client';

import { Contact } from '@/components/contact';
import { MainLayout } from '@/layouts/main';
import Head from 'next/head';
import { generateNextSeo } from 'next-seo/pages';
import type { FC } from 'react';

type ContactPageClientProps = {
  locale: string;
};

export const ContactPage: FC<ContactPageClientProps> = ({ locale }) => {
  return (
    <>
      <Head>{generateNextSeo({
        title: `Contact - ${locale}`,
        description: `Contact us - ${locale}`
      })}</Head>
      <MainLayout>
        <div className="bg-[#0A0A0A] relative">
          <Contact />
        </div>
      </MainLayout>
    </>
  );
};
